<template>
  <div>
       <!--采购报表-->
      <header class="form-title">
          <Row>
              <Col span="24">
                  <Form  inline  :label-width="100" >
                      <FormItem  label="选择时间" style="margin-right:100px">
                          <DatePicker
                                  split-panels
                                  type="daterange"
                                  :options="options"
                                  placeholder="选择日期"
                                  @on-change="modifyTime"
                                  :value="valuedate"
                                  >
                          </DatePicker>
                      </FormItem>
                      
                      <FormItem  label="采购笔数:" style="margin-right: 30px">
                          <strong class="result">{{dataTotl.count}}</strong>
                      </FormItem>
                      <FormItem  label="采购单品数:" style="margin-right: 30px">
                          <strong class="result">{{dataTotl.total}}</strong>
                      </FormItem>
                      <FormItem  label="采购金额:">
                          <strong class="result">{{dataTotl.money}}</strong>
                      </FormItem>
                      <FormItem>
              <Button type="primary" @click="exportExcel">导出excel</Button>
            </FormItem>
                  </Form>
                  
             </Col>
          </Row>
      </header>
      <Table stripe :columns="columns" :data="data" :loading="loadingTable">
          <template slot-scope="{ row, index }" slot="action">
              <Button type="primary" size="small" @click="$router.push({path:'/purchaseDetail',query:{id:row.id}})">详情</Button>
          </template>
      </Table>
      <div class="pageTotal"  >
          <Page :total="page.total"
                show-total
                :page-size="page.rows"
                @on-change="onGongPageTotal" />
      </div>
  </div>
</template>
<script>
import { exportExcel } from '@/common/exportExcel';
export default {
  data() {
    return {
        cid:'',
        sid:'',
        options: {
            shortcuts: [
                {
                    text: '昨日',
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 *1);
                        return [start, start];
                    },
                },
                {
                    text: '今日',
                    value () {
                        const end = new Date();
                        const start = new Date();
                        return [start, end];
                    },
                },
                {
                    text: '近七日',
                    value () {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        return [start, end];
                    },

                }
            ],
        },
        columns: [
            {title: '表单类型', key: 'type',align:'center',className:'tableFirst' },
            {title: '供应商名称', key: 'name',align:'center' },
            {title: '订单号', key: 'order' ,align:'center',width:'300' },
            {title: '数量', key: 'number' ,align:'center' },
            {title: '采购金额', key: 'money',align:'center'  },
            {title: '时间', key: 'time' ,align:'center' },
            {title: '操作', key: 'edit' ,align:'center',slot: 'action',},
        ],
        data: [],
        dataTotl:{},
        loadingTable:true,
        page:{
            total:0,
            page:1,
            rows:12
        }
    };
  },
    created: function() {
        //获取用户信息
        this.cid= JSON.parse(localStorage.getItem('shop')).cid
        this.sid = JSON.parse(localStorage.getItem('shop')).id
        this.valuedate[0] = this.fun_date(-7)
        this.valuedate[1] = this.nowTime
        this.getPurchaseList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
    },

  methods: {

    exportExcel() {
      const params = {
        cid: this.cid,
              sid: this.sid,
              time: this.valuedate[0],
              endtime:this.valuedate[1],
              state: 1,
      };
      exportExcel(this.$Api.exportPurchaseList, params, this.$Message,new Date().toLocaleString()+'采购报表');
  },
      //获取采购单
      getPurchaseList(page,rows,startTime,endTime){
          this.$Api.getPurchaseList({
              cid: this.cid,
              sid: this.sid,
              page: page,
              rows: rows,
              time: startTime,
              endtime:endTime,
              state: 1,
          }).then(res => {
              if(res.code==200){
                  this.page.total = res.count
                   this.data=[]
                  res.data.forEach((item,index)=>{
                      var PurchaseList={}
                      PurchaseList.id = item.id,
                      PurchaseList.type = '采购单',
                      PurchaseList.name=item.suppliername,
                      PurchaseList.order= item.purchasecode,
                      PurchaseList.number=item.total,
                      PurchaseList.money= item.money,
                      PurchaseList.time=item.time
                      this.data.push(PurchaseList)
                  })
                  this.loadingTable=false
                  this.getSumPurchase(page,rows,startTime,endTime)
              }else {
                  this.$Message.warning(res.msg);
              }
          });

      },
      //采购合计
      getSumPurchase(page,rows,startTime,endTime){

          this.$Api.getSumPurchase({
              cid: this.cid,
              sid: this.sid,
              page: page,
              rows: rows,
              time: startTime,
              endtime:endTime,
              state: 1,
          }).then(res => {
              if(res.code==200){
                this.dataTotl = res.data
              }else {
                  this.$Message.warning(res.msg);
              }
          });
      },
      modifyTime(time){
          this.valuedate[0]=time[0]
          this.valuedate[1]=time[1]
          this.getPurchaseList(this.page.page,this.page.rows,this.valuedate[0],this.valuedate[1])
      },
      onGongPageTotal(num){
          this.getPurchaseList(num,this.page.rows,this.valuedate[0],this.valuedate[1])
      }
  }
};
</script>

<style lang="scss" scoped>
  .form-title{

    line-height: 54px;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
.result{
    color: #ff5e5e;

}
  .tableFirst{
       color: #ff5e5e;
   }
</style>